import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import moment from 'moment'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import financeActions from 'actions/financeActions'

import { reportType } from 'selectors/reports'


let select = (state, props) => ({
	report: reportType(state)
})

let reports = ['Monthly Statement', '1099']

export class ReportSelect extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render () {
		let {props} = this
		return (
			<div
				className="report-holder"
				style={{display: "flex"}}
			>
				<div
					className="value"
					onClick={this.toggleMenu}
					style={{
						cursor: "pointer"
					}}
				>
					{props.report}
				</div>
				<IconMenu
					open={this.state.isOpen}
					onRequestChange={this.toggleMenu}
					iconButtonElement={
						<IconButton style={{paddingLeft: '0px', verticalAlign: 'middle', marginTop: '-3px'}}>
							<ArrowDropDown	color='#FFF'/>
						</IconButton>
					}
					onItemTouchTap={(evt, item) => {
						props.SET_REPORT_TYPE(item.key)
					}}
				>
					{R.map(
						report => (
							<MenuItem key={report} value={report} primaryText={report}/>)
						)(reports)
					}
				</IconMenu>
			</div>
		)
	}
}
export default connect(select, financeActions)(ReportSelect)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/ReportSelect.js